/* ==================================================
   File: src/components/employees/EmployeeDetailsDrawer/hooks/useLocations.ts
   Hook to fetch branches/locations (replace with your BranchOperation)
   ================================================== */
import { useContext, useEffect, useState } from "react";
import { LocationType } from "../EmployeeDetailsDrawer/types";
import { BranchOperation } from "../../../serviceoperation/BranchOperation";
import { CompanyContext } from "../../../contexts/company-context";

export const useLocations = () => {
  const [locations, setLocations] = useState<LocationType[]>([]);
  const { selectedCompany } = useContext(CompanyContext);

  useEffect(() => {
    const branchOps = new BranchOperation();
    branchOps
      .getBranchAsync(selectedCompany?.corporationId as number)
      .then((value) => {
        if (value.data) {
          setLocations(
            value.data.map((s) => ({
              key: s.branchID,
              name: s.name,
              color: s.color,
            }))
          );
        }
      });
  }, [selectedCompany]);

  return { locations };
};